import { useTranslation } from "react-i18next";
import { DEVICE_SOFTWARE_VERSION } from "lib/consts/deviceVersion";

const HARDWARE_VERSION = "2.1.6";
const MODEL_NAME = "ARC GEN 2";

const AboutDevicePanel: React.FC = () => {
    const { t } = useTranslation("settings");

    const rows: { labelKey: string; value: string }[] = [
        { labelKey: "aboutDevice.softwareVersion", value: DEVICE_SOFTWARE_VERSION },
        { labelKey: "aboutDevice.hardwareVersion", value: HARDWARE_VERSION },
        { labelKey: "aboutDevice.modelName", value: MODEL_NAME },
    ];

    return (
        <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col">
            <div className="shrink-0 border-b border-black80 pb-4">
                <p className="text-h4 font-semibold text-white">{t("aboutDevice.title")}</p>
            </div>
            <dl className="mt-6 max-w-md space-y-4">
                {rows.map(({ labelKey, value }) => (
                    <div key={labelKey} className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:gap-4">
                        <dt className="shrink-0 text-h5 text-black40">{t(labelKey)}</dt>
                        <dd className="text-h5 font-semibold text-white">{value}</dd>
                    </div>
                ))}
            </dl>
        </div>
    );
};

export default AboutDevicePanel;
